import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;
  align-items: center;

  padding: 1rem;

  background-color: ${pickColor('warning')};
  color: ${pickColor('warningText')};
  border: 0.1rem solid ${pickColor('warningBorder')};
`;

const Text = styled(Headline)`
  margin-left: 0.5rem;
`;

export { Container, Text };
